/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dropmessagesent2Inputs */

const en_dropmessagesent2 = /** @type {(inputs: Dropmessagesent2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Message sent`)
};

const de_dropmessagesent2 = /** @type {(inputs: Dropmessagesent2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nachricht gesendet`)
};

/**
* | output |
* | --- |
* | "Message sent" |
*
* @param {Dropmessagesent2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const dropmessagesent2 = /** @type {((inputs?: Dropmessagesent2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dropmessagesent2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dropmessagesent2(inputs)
	return de_dropmessagesent2(inputs)
});
export { dropmessagesent2 as "dropMessageSent" }